import React from "react";
import s from "../labReportPdf.module.scss";

const DengueRapidReport = ({ profile, PageBaseLayout, PageFooter }) => {
  const tests = profile.tests || [];

  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout showSampleType={true} currentSampleType={profile.sampleType} />
      
      <div className={s.testCategoryHeader}>
        {profile.profileName.toUpperCase()}
      </div>

      <table className={s.resultsTable} style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#fafafa" }}>
            <th style={{ width: "45%", textAlign: "left", padding: "8px" }}>Test Description</th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          <tr className={s.sectionHeaderRow}>
            <td colSpan="4" style={{ fontWeight: "bold", backgroundColor: "#f2f2f2", padding: "8px", textAlign: "left" }}>
              SEROLOGY
            </td>
          </tr>
          {tests.map((t, idx) => (
            <tr key={idx}>
              <td style={{ paddingLeft: "15px", borderBottom: "1px solid #eee" }}>
                {t.testName}
              </td>
              <td align="center" style={{ 
                borderBottom: "1px solid #eee",
                fontWeight: t.value?.toLowerCase().includes("reactive") && !t.value?.toLowerCase().includes("non") ? "bold" : "normal"
              }}>
                {t.value || "-"}
              </td>
              <td align="center" style={{ borderBottom: "1px solid #eee" }}>
                {t.units || "-"}
              </td>
              <td align="center" style={{ borderBottom: "1px solid #eee" }}>
                {t.reference_range_details || "Non Reactive"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: "20px", fontSize: "11px", color: "#555" }}>
        <p>• {profile.profileName} result confirms presence or absence of antibodies/antigens.</p>
        <p style={{ fontStyle: "italic", marginTop: "10px" }}>
          * The above results are subject to variations due to technical limitation[cite: 65].
        </p>
        <p style={{ fontStyle: "italic" }}>
          * Hence correlation with clinical findings and other investigations should be done[cite: 66].
        </p>
      </div>

      <PageFooter />
    </div>
  );
};

export default DengueRapidReport;